<template>
    <div class="side-menu" :class="{ active: mobileToggle, 'menu-small': isSmallMenu }" ref="side-menu">
        <!-- Hide Menu Button -->
        <!-- Should add menu-small to menu element -->
        <div class="menu-btn h-effect" @click="toggleSmallMenu">
            <b-icon pack="mdi" :icon="isSmallMenu ? 'arrow-collapse-right' : 'arrow-collapse-left'" />
        </div>
        <div class="mobile-btn h-effect" @click="mobileToggle = !mobileToggle"><i class="fas fa-2x fa-angle-double-left"></i></div>
        <div class="image-logo my-5">
            <img :src="logo" />
        </div>

        <p class="panel-title">{{ panelName }}</p>

        <aside class="menu">
            <div v-for="(item, index) in menu" :key="index">
                <p class="menu-label" v-if="item.title">
                    {{ item.title }}
                </p>
                <ul class="menu-list" v-else>
                    <li>
                        <router-link :to="item.url">
                            <b-icon pack="mdi" :icon="item.icon" size="is-medium" />
                            <!-- <i class="fas fas fa-info-circle"></i> -->
                            <span class="menu-title">{{ item.name }}</span>
                        </router-link>
                    </li>
                </ul>
            </div>

            <!-- SPACER -->
            <!-- <div class="bottom-menu-spacer" v-for="(array, index) in bottom" :key="index">
                <p class="menu-label">
                    {{ index }}
                </p>
                <ul class="menu-list">
                    <li v-for="(item, index) in array" :key="index">
                        <a>
                            <b-icon pack="fas" icon="info-circle" size="is-medium"> </b-icon>
                            <span class="menu-title">{{ item.name }}</span>
                        </a>
                    </li>
                </ul>
            </div> -->

            <!-- Bottom Items -->
            <!-- <div class="bottom-menu" v-for="(array, index) in bottom" :key="index">
                <p class="menu-label">
                    {{ index }}
                </p>
                <ul class="menu-list">
                    <li v-for="(item, index) in array" :key="index">
                        <router-link :to="item.url">
                            <b-icon pack="fas" :icon="item.icon" size="is-medium"> </b-icon>
                            <span class="menu-title">{{ item.name }}</span>
                        </router-link>
                    </li>
                </ul>
            </div> -->
        </aside>
    </div>
</template>

<script>
export default {
    watch: {
        $route() {
            this.mobileToggle = false;
        },
        // windowWidth(newWidth) {
        //     if (newWidth > 768) {
        //         this.endClass = false;
        //         setTimeout(() => (this.endClass = true), 150);
        //     }
        // },
    },
    props: {
        panelName: {
            default: "Control Panel",
            type: String,
        },
        logo: {
            default: "",
            type: String,
        },
        menu: {},
        // bottom: {},
    },
    data() {
        return {
            isSmallMenu: false,
            mobileToggle: false,
            windowWidth: window.innerWidth,
        };
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    methods: {
        onResize() {
            this.windowWidth = window.innerWidth;
        },
        toggleSmallMenu() {
            this.isSmallMenu = !this.isSmallMenu;
            this.$parent.isSmallMenu = !this.$parent.isSmallMenu;
        },
    },
    mounted() {
        // this.toggleSmallMenu();
        this.$nextTick(() => {
            window.addEventListener("resize", this.onResize);
        });
    },
};
</script>

<style>
.image-logo img {
    max-height: 250px !important;
}
</style>